import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from './SimpleNav.module.scss';

export default function SimpleNav() {
  const router = useRouter();

  return (
    <div className={styles.simpleNav}>
      <a onClick={() => router.back()} className={styles.simpleNav__backBtn}>
        <img alt="Lifepal Back Button" src="/media/static/images/icons/back-btn.png" />
      </a>

      <Link href="/">
        <div className={styles.simpleNav__logo}>
          <img alt="Lifepal Logo" src="/media/static/images/lifepal-logo.png" />
        </div>
      </Link>
    </div>
  );
}
